










import Vue from "vue";
import { PropValidator } from "vue/types/options";
import TypeToken from "./TypeToken.vue";

export default Vue.extend({
  components: { TypeToken },
  props: {
    propTypes: { type: Array, required: true } as PropValidator<string[]>
  }
});
